export default {
  switch: "切换语言",
  zhCN: "简体中文",
  zhHK: "繁体中文",
  en: "English",
};
